export default __webpack_public_path__ + "static/media/Websites-Amazon2.a6cb559c.png";